import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import Helpers from "@utils/Helpers";
import { TProfileEdit } from "@utils/Interfaces";
import { Input, Button } from "antd";
import { useState } from "react";

const HardSkillEdit: React.FC<TProfileEdit> = ({ data, handleChangeValue }) => {
  const [skill, setSkill] = useState("");
  const notification = Helpers.notification;

  const handleAddSkill = () => {
    if (skill == "") {
      return;
    }
    const skillArray: string[] = [...(data.skills || [])];
    const lowercaseSkillArray = skillArray.map((item) => item.toLowerCase());

    if (!lowercaseSkillArray.includes(skill)) {
      skillArray.push(skill);
      handleChangeValue(skillArray, "skills");
      setSkill("");
    } else {
      notification.warning(skill + " is already exists");
    }
  };

  const removeSkill = (indexToRemove: any) => {
    const skillArray: string[] = [...(data.skills || [])];
    const updatedItems = skillArray.filter(
      (_, index) => index !== indexToRemove
    );
    handleChangeValue(updatedItems, "skills");
  };
  return (
    <div className="SkillEdit">
      <div className="d-flex gap-2 align-items-center">
        <Input
          onChange={(e) => setSkill(e.target.value)}
          onKeyDown={(e) => {
            if (e.key == "Enter") {
              handleAddSkill();
            }
          }}
          size="large"
          value={skill}
          prefix={<SearchOutlined />}
        />
        <Button onClick={handleAddSkill} className="add-btn" size="large">
          Add
        </Button>
      </div>
      <div className="skill-group">
        {data.skills?.map((item, index) => {
          return (
            <div
              className="skill-item"
              onClick={() => removeSkill(index)}
              key={index}
            >
              <span>{item}</span>
              <CloseOutlined style={{ fontSize: 10 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HardSkillEdit;
